/**
 * @file
 * PDP detail block module. contain methods and function that manages
 * pdp detail block features and behavior, including:
 * - accordion initialization
 * - slider
 *
 * @author Glory Wiguno <glory@relab.com.au>
 */

// ---- constants ----
const accordionSel = "js-detail-accordion";
const accordionTriggerSel = accordionSel + "__trigger";
const accordionDrawerSel = accordionSel + "__drawer";
const accordionClass = "pdp-detail-accordion";
// var sliderId = "specs-main-slider";
// var thumbSliderId = "specs-thumb-slider";
// var activeThumbSliderClass = "thumbs--active";

// ---- variables ----
let detailSection;
// var specsSlider;
// var thumbSlider;
// var currentActiveSlide;


const init = function() {
  detailSection = document.getElementById("pdp-details");
  if (detailSection === undefined) {
    return;
  }

  initAccordion();
  // initSlider();
};


/**
 * @name initSlider
 * @function
 * initializes the slider that is in pdp detail block specifications section
 */
// var initSlider = function() {
//   var specSlideEl = document.getElementById(sliderId);
//   var thumbSlideEl = document.getElementById(thumbSliderId);
//
//   if (specSlideEl != null) {
//     specsSlider = new Swiper("#" + sliderId, {
//       threshold: 50, navigation: {
//         nextEl: ".js-specs-main-slider--next", prevEl: ".js-specs-main-slider--prev", disabledClass: "specs-slider__nav--disabled"
//       }
//     });
//
//     lightGallery(document.getElementById(sliderId), {
//       selector: ".js-slider-lightbox", thumbnail: true
//     });
//
//     specsSlider.on("slideChange", syncSlideChangesToThumbnail);
//   }
//
//   if (thumbSlideEl != null) {
//     thumbSlider = new Swiper("#" + thumbSliderId, {
//       slidesPerView: 'auto', direction: "horizontal", threshold: 50, navigation: {
//         nextEl: ".js-specs-thumb-slider--next", prevEl: ".js-specs-thumb-slider--prev", disabledClass: "specs-slider__nav--disabled"
//       }
//     });
//
//   }
//
//   if (specsSlider && thumbSlider) {
//     assignThumbSliderClick();
//   }
// };


/**
 * @name assignThumbSliderClick
 * @function
 * assign click handler for thumbnail slider click
 */
// var assignThumbSliderClick = function() {
//   if (thumbSlider == undefined) {
//     return;
//   }
//
//   var slider = document.getElementById(thumbSliderId);
//   var slides = slider.querySelectorAll(".swiper-slide");
//
//   for (var i = 0; i < slides.length; i++) {
//     slides[i].onclick = handleThumbClick;
//   }
// };


/**
 * @name handleThumbClick
 * @function
 * function handler for thumbnail slider click.
 * will trigger specs slider to slide to the clicked slide in thumb slider
 */
// var handleThumbClick = function() {
//   if (specsSlider == undefined) {
//     return;
//   }
//
//   specsSlider.slideTo(thumbSlider.clickedIndex);
// };


/**
 * @name syncSlideChangesToThumbnail
 * @function
 * add active class to thumbnail slider based on the active slide in main slider
 *
 */
// var syncSlideChangesToThumbnail = function () {
//   var prevActive = currentActiveSlide;
//   currentActiveSlide = specsSlider.realIndex;
//
//   if (thumbSlider != null) {
//     if (prevActive != null) classie.remove(thumbSlider.slides[prevActive], activeThumbSliderClass);
//     classie.add(thumbSlider.slides[currentActiveSlide], activeThumbSliderClass);
//   }
// };


/**
 * @name initAccordion
 * @function
 * initializes the accordion trigger fore detail block;
 */
const initAccordion = function() {
  var triggers = detailSection.querySelectorAll("." + accordionTriggerSel);

  for (var i = 0; i < triggers.length; i++) {
    triggers[i].onclick = handleAccordionTrigger;
  }
};


/**
 * @name handleAccordionTrigger
 * @function
 * handler function for accordion trigger click
 *
 * @param {Event} e - event that is passed into the function
 */
const handleAccordionTrigger = function(e) {
  const parent = e.currentTarget.parentElement;
  const drawer = parent.querySelector("." + accordionDrawerSel);
  const drawerActive = accordionClass + "--active";

  
  if (parent.classList.contains(drawerActive)) {
    parent.classList.remove(drawerActive);
    drawer.removeAttribute("style");
  } else {
    parent.classList.add(drawerActive);
    drawer.setAttribute("style", "max-height: " + drawer.scrollHeight + "px;");
  }
};

export default {init};
